import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'lempole_cookie_choice_v2';
const POLICY_URL = 'https://www.iubenda.com/privacy-policy/50690964/cookie-policy';

const COPY = {
  it: {
    aria: 'Informativa cookie',
    text: 'Usiamo solo cookie tecnici per far funzionare il sito. Nessun tracker pubblicitario.',
    link: 'Cookie policy',
    accept: 'Accetta',
    reject: 'Rifiuta',
  },
  en: {
    aria: 'Cookie notice',
    text: 'We only use technical cookies to make the site work. No advertising trackers.',
    link: 'Cookie policy',
    accept: 'Accept',
    reject: 'Decline',
  },
  fr: {
    aria: 'Avis cookies',
    text: 'Nous n\u2019utilisons que des cookies techniques pour faire fonctionner le site. Aucun traceur publicitaire.',
    link: 'Politique cookies',
    accept: 'Accepter',
    reject: 'Refuser',
  },
};

const SUPPORTED = ['it', 'en', 'fr'];

function detectLang() {
  if (typeof window === 'undefined') return 'it';
  const url = new URLSearchParams(window.location.search).get('lang');
  if (SUPPORTED.includes(url)) return url;
  try {
    const stored = localStorage.getItem('lempole_lang');
    if (SUPPORTED.includes(stored)) return stored;
  } catch (_) {}
  return 'it';
}

/**
 * CookieBanner — quiet, GDPR-informative notice pinned to the bottom.
 * The site only uses technical cookies / localStorage so the two buttons
 * simply dismiss the notice; the user's choice is stored in localStorage
 * so the banner never re-appears once decided.
 */
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  // Sync language on URL change (nav toggles use history.replaceState)
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const sync = () => setLang(detectLang());
    window.addEventListener('popstate', sync);
    window.addEventListener('focus', sync);
    const id = setInterval(sync, 800);
    return () => {
      window.removeEventListener('popstate', sync);
      window.removeEventListener('focus', sync);
      clearInterval(id);
    };
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;
  const c = COPY[lang] || COPY.it;

  return (
    <div className="cookie-banner" role="dialog" aria-label={c.aria} data-testid="cookie-banner">
      <p className="cookie-banner__text">
        {c.text}{' '}
        <a
          href={POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="cookie-banner__link"
          data-testid="cookie-policy-link"
        >
          {c.link}
        </a>
        .
      </p>
      <div className="cookie-banner__actions">
        <button
          type="button"
          onClick={() => persist('rejected')}
          className="cookie-banner__btn cookie-banner__btn--ghost"
          data-testid="cookie-reject-btn"
        >
          {c.reject}
        </button>
        <button
          type="button"
          onClick={() => persist('accepted')}
          className="cookie-banner__btn cookie-banner__btn--accept"
          data-testid="cookie-accept-btn"
        >
          {c.accept}
        </button>
      </div>
    </div>
  );
}
